var SENTRY_RELEASE;SENTRY_RELEASE={name: "Flavrly", version: "3.8.0"};